import createAuth from './auth'
import createStatus from './status'
import createPlayer from './player'
import createMc from './mc'
import createSuperAdmin from './superadmin'

export default (type, socket) => {
    console.tron.log('SOCKET: INIT EMITTERS')

    const commonEmitters = {
        auth: createAuth(socket)
    }

    if (type === 'superadmin') {
        // Only Super Admin emitters
        return {
            ...commonEmitters,
            superadmin: createSuperAdmin(socket)
        }
    }
    if (type === 'admin') {
        // Only ceremonies master emitters
        return {
            ...commonEmitters,
            mc: createMc(socket)
        }
    }
    // Only player emitters
    return {
        ...commonEmitters,
        status: createStatus(socket),
        player: createPlayer(socket)
    }
}



// WEBPACK FOOTER //
// src/api/emitters/index.js